<div mat-dialog-content >
    <div>
        <iframe (load)="exit()" style="width: 100%;height:600px;border:0;"  [srcdoc]="responseForm"></iframe>
    </div>
</div>